import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledTableColumnsContent = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--table-columns-content-rows': `${props.$rows}`
    };

    return utils.styleProps(attr, vars);
  })`
  width: 100%;
  
  .Form {
    .Form-fields {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(${props => props.$css.$var('--table-columns-content-rows', false)}, auto);
      grid-auto-flow: column;
      gap: unset;
      padding: ${props => props.theme.spacing(0.5)};

      .CheckboxField {
        min-height: unset !important;
      }
    }
  }
  ${ComponentStyles}
`;

StyledTableColumnsContent.propTypes = {
  theme: PropTypes.object
};

export default StyledTableColumnsContent;
